import { ChangeDetectionStrategy, Component } from '@angular/core'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { JsspSettingsBrowserComponent } from '../../jssp-settings/jssp-settings-browser/jssp-settings-browser.component'
import { OptimisationSettingsScheduleComponent } from '../optimisation-schedule-settings/optimisation-settings-schedule.component'
import {
  ElderTabGroupRoutingDirective,
  ElderTabDirective,
  ElderPaneComponent,
  ElderBasicPaneLayoutComponent,
} from '@elderbyte/ngx-starter'
import { MatTabGroup, MatTab } from '@angular/material/tabs'

@Component({
  selector: 'app-optimisation-settings-container',
  templateUrl: './optimisation-settings-container.component.html',
  styleUrls: ['./optimisation-settings-container.component.scss'],
  imports: [
    MatTabGroup,
    ElderTabGroupRoutingDirective,
    MatTab,
    ElderTabDirective,
    OptimisationSettingsScheduleComponent,
    JsspSettingsBrowserComponent,
    ElderTranslatePipe,
    ElderBasicPaneLayoutComponent,
    ElderPaneComponent,
  ],
})
export class OptimisationSettingsContainerComponent {}
